import { createReduxHistory } from './store';
import { store } from './persist';

//use this history obj across app
export const history = createReduxHistory(store);
